import { Grid, GridItem, useMediaQuery } from '@chakra-ui/react'
import { Header } from 'components/molecules/Header'
import { Sidebar } from 'components/molecules/Sidebar'
import { media } from 'components/utils/breakpoints'
import { useAuthContext } from 'contexts/auth'
import jwt_decode from 'jwt-decode'
import { AuthTokens } from 'models'
import ModalNotification, {
    TypeModalNotification
} from 'pages/components/ModalNotification'
import React, { useEffect, useState } from 'react'
import { getNotifications } from 'services/notifications'
import { canMakeRequest, setLastRequestTime } from 'utils/notificationControl'
import { DefaultPageProps } from './interfaces'

export const DefaultPage: React.FC<DefaultPageProps> = ({ children }) => {
    const [isMedium] = useMediaQuery(media('md'))
    const { currentUser } = useAuthContext()
    const decodedIdToken =
        currentUser && (jwt_decode(currentUser?.idToken) as AuthTokens)
    const [listNotifications, setListNotifications] = useState<
        TypeModalNotification[]
    >([])

    const fetchNotifications = async () => {
        const idUser = decodedIdToken!['custom:usuario_guid']
        if (!canMakeRequest(idUser)) return
        const { data: notifications } = await getNotifications(idUser)
        setListNotifications(notifications)
        setLastRequestTime(idUser)
    }

    const { isBackoffice } = useAuthContext()

    useEffect(() => {
        fetchNotifications()
    }, [])

    return (
        <Grid
            data-testid="default-page"
            templateAreas={{
                base: `"header" "main" "footer"`,
                md: `"nav header" "nav main" "nav footer"`
            }}
            gridTemplateRows={{
                base: `auto 1fr auto`
            }}
            gridTemplateColumns={{
                base: `1fr`,
                md: `auto 1fr`
            }}
            h="100vh"
            color="blackAlpha.900"
            bgColor="backdrop"
            overflowY="auto"
        >
            <GridItem area={'header'} data-testid="default-page-header">
                <Header variant={isMedium ? 'desktop' : 'mobile'} />
            </GridItem>
            {isMedium && (
                <GridItem
                    area={'nav'}
                    zIndex={1}
                    data-testid="default-page-nav"
                >
                    <Sidebar />
                </GridItem>
            )}
            <GridItem
                area={'main'}
                overflowY="auto"
                px={[4, 6]}
                py={[2]}
                data-testid="default-page-main"
            >
                {children}
            </GridItem>

            {listNotifications?.length && !isBackoffice ? (
                <ModalNotification />
            ) : (
                <></>
            )}
        </Grid>
    )
}
